<template>
  <div>
    <navigation-bar></navigation-bar>

    <!-- Hauptinhalt -->
    <div class="container-fluid mt-2">
      <h1>
        <i class="fas fa-edit"></i> Megrendelés szerkesztése
      </h1>

      <form id="editOrderForm" v-if="megrendeles" @submit.prevent="saveOrder">
      
      
        <!-- Megrendelő -->
        <div class="form-group row align-items-center">
          <label for="megrendelo_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Megrendelő</label>
          <!-- Eingabefeld mit aktuellem Wert -->
          <div class="col-sm-2 col-md-2">
            <input 
              type="text" 
               class="form-control-plaintext px-0"
              :value="megrendeles.megrendelo" 
              readonly>
          </div>
          <!-- Select2 Dropdown -->
          <div class="col-sm-2 col-md-2">
            <select id="megrendelo_select" class="form-control"></select>
          </div>
        </div>



          <!-- Felrakó -->
          <div class="form-group row align-items-center">
            <label for="felrako_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Felrakó</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0"
              :value="megrendeles.felrako" readonly>
            </div>
            <div class="col-sm-2 col-md-2">
              <select id="felrako_select" class="form-control"></select>
            </div>
          </div>


          <!-- Felrakó hely-->
          <div class="form-group row align-items-center">
            <label for="felhely_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Felrakó hely</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0"
              :value="megrendeles.fhely" readonly>
            </div>
            <div class="col-sm-2 col-md-2">
              <select id="felhely_select" class="form-control"></select>
            </div>
          </div>







          <!-- Lerakó -->
        <div class="form-group row align-items-center">
          <label for="lerako_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Lerakó</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0"
              :value="megrendeles.lerako" readonly>
            </div>
            <div class="col-sm-2 col-md-2">
              <select id="lerako_select" class="form-control"></select>
            </div>
          </div>
        
   <!-- Lerakó hely-->
   <div class="form-group row align-items-center">
          <label for="lerakohely_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Lerakó hely</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0"
              :value="megrendeles.lhely" readonly>
            </div>
            <div class="col-sm-2 col-md-2">
              <select id="lerakohely_select" class="form-control"></select>
            </div>
          </div>

          <!-- Cikk -->
          <div class="form-group row align-items-center">
          <label for="cikk_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Cikk</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0" 
              :value="megrendeles.cikk" readonly>
            </div>
            <div class="col-sm-2 col-md-2">
              <select id="cikk_select" class="form-control"></select>
            </div>
          </div>

 <!-- mennyiseg -->
        <div class="form-group row align-items-center">
          <label for="mennyiseg" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Mennyiség</label>
            <div class="col-sm-2 col-md-2">
              <input type="text" 
              class="form-control-plaintext px-0" 
              :value="megrendeles.m_suly" readonly>
            </div>
          </div>

<!-- km + útvonal -->
<div class="form-group row align-items-center">
  <label for="tavolsag" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">
    Távolság
  </label>

  <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="text" 
    class="form-control-plaintext px-0" 
    :value="megrendeles.m_km" readonly>
  </div>

  <!-- Neues Feld zur Eingabe -->
  <div class="col-sm-2 col-md-2">
    <input
      type="number"
      class="form-control"
      id="tavolsag_neu"
      step="0.01"
      v-model="newKm"
      placeholder="Új távolság"
      @input="recalcKmDiff"
    >
  </div>

  <!-- Route-Info + Buttons in derselben Zeile -->
  <div class="col-sm-7 col-md-7 d-flex align-items-center flex-wrap">

    <small v-if="utvonalKm !== null" class="text-muted mr-3">
      Útvonal (pontvonal_hossz): <b>{{ formatKm(utvonalKm) }}</b> km
      <span v-if="kmDiffPct !== null"> — Diff: <b>{{ kmDiffPct }}%</b></span>
      <span v-if="utvonalViszonylat"> — {{ utvonalViszonylat }}</span>
    </small>

    <button
      type="button"
      class="btn btn-outline-primary btn-sm mr-2"
      :disabled="!canLoadUtvonal || routeLoading"
      @click="loadUtvonal"
    >
      <span v-if="routeLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
      Útvonal keresése
    </button>

    <button
      type="button"
      class="btn btn-outline-secondary btn-sm mr-2"
      :disabled="!utvonalPolyline"
      @click="openUtvonalModal"
    >
      Térkép
    </button>

    <span v-if="utvonalAz" class="badge badge-success mr-2">utvonalAz: {{ utvonalAz }}</span>
    <span v-else-if="routeTried && !routeLoading" class="badge badge-warning mr-2">Nincs útvonal</span>

  </div>
</div>






<!-- szállítás kezdete -->
<div class="form-group row align-items-center">
  <label for="ido" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Szállítás kezdete</label>
    <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="date" class="form-control-plaintext px-0" :value="megrendeles.m_datumtol" readonly>
  </div>
  <label for="ido2" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">határideje</label>
    <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="date" class="form-control-plaintext px-0" :value="megrendeles.szall_hatarido" readonly>
  </div>

  </div>


  <!-- hivatkozási szám -->
<div class="form-group row align-items-center">
  <label for="hivatkozasi_szam" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Hivatkozási szám</label>
  
  <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control-plaintext px-0" :value="megrendeles.hivatkozasi_szam" readonly>
  </div>
  
  <!-- Neues Feld zur Eingabe -->
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control" id="hivatkozasi_szam" v-model="newHivatkozasi_szam" placeholder="Új hivatkozási szám">
  </div>
</div>


<!-- GMP -->
<div class="form-group row align-items-center">
  <label for="gmp" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">GMP</label>
  
  <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="checkbox" :checked="megrendeles.gmp == -1" disabled>
  </div>
  
  <!-- Neues Feld zur Eingabe -->
  <div class="col-sm-2 col-md-2">
    <input type="checkbox" id="gmp" v-model="newGMP">
  </div>
</div>


<!-- Megrendelői ár -->
<div class="form-group row align-items-center">
  <label for="megrendelo_ar" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Megrendelői ár</label>
  
  <!-- Altes Feld (readonly) -->
  <div class="col-sm-2 col-md-2">
    <input type="number" class="form-control-plaintext px-0" :value="megrendeles.m_aregysegar" readonly>
  </div>
  
  <!-- Neues Feld zur Eingabe -->
  <div class="col-sm-2 col-md-2">
    <input type="number" class="form-control" id="megrendelo_ar" step="0.01"  v-model="newMegrendeloAr" placeholder="Új nagyár">
  </div>
</div>



<!-- Megrendelői ártípus -->
<div class="form-group row align-items-center">
  <!-- Altes Feld (readonly) -->
  <label for="tip_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Megr. ártípus</label>
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control-plaintext px-0" :value="megrendeles.m_egysegarme" readonly>
  </div>

  <!-- Neues Feld zur Auswahl -->
  <div class="col-sm-2 col-md-2">
    <select id="tip_select" class="form-control"></select>
  </div>
</div>


<!-- Alvállalkozói ár -->
<div class="form-group row align-items-center">
  <!-- Altes Feld (readonly) -->
  <label for="alv_ar" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Alváll. ár</label>
  <div class="col-sm-2 col-md-2">
    <input type="number" class="form-control-plaintext px-0" :value="megrendeles.mar_egysegar" readonly>
  </div>

  <!-- Neues Feld zur Eingabe -->
  <div class="col-sm-2 col-md-2">
    <input type="number" class="form-control" id="alv_ar" step="0.01" v-model="newAlvAr" placeholder="Új kisár">
  </div>
</div>

<!-- Alvállalkozói ártípus -->
<div class="form-group row align-items-center">
  <!-- Altes Feld (readonly) -->
  <label for="alvTip_select" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Alv. ártípus</label>
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control-plaintext px-0" :value="megrendeles.mar_egysegarme" readonly>
  </div>

  <!-- Neues Feld zur Auswahl -->
  <div class="col-sm-2 col-md-2">
    <select id="alvTip_select" class="form-control"></select>
  </div>
</div>

<!-- Megjegyzés -->
<div class="form-group row align-items-center">
  <!-- Altes Feld (readonly) -->
  <label for="megjegyzes_alt" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Megjegyzés</label>
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control-plaintext px-0" :value="megrendeles.megjegyzes" readonly>
  </div>

  <!-- Neues Feld -->
  
  <div class="col-sm-3 col-md-3">
    <input type="text" class="form-control" v-model="newMegjegyzes" placeholder="Új megjegyzés">
  </div>
</div>

<!-- Belső Hivatkozás -->
<div class="form-group row align-items-center">
  <!-- Altes Feld (readonly) -->
  <label for="belsoHivatkozas_alt" class="col-form-label col-sm-1 col-md-1 d-flex align-items-center">Belső hiv.szám</label>
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control-plaintext px-0" :value="megrendeles.belsoHivatkozas" readonly>
  </div>

  <!-- Neues Feld -->
 
  <div class="col-sm-2 col-md-2">
    <input type="text" class="form-control" v-model="newBelsoHivatkozas" placeholder="Új belső hivatkozási szám">
  </div>
</div>




        <!-- Buttons -->
        <div class="form-group btn-container">
          <button type="button" class="btn btn-danger" @click="cancel">Mégse</button>
          <button type="submit" class="btn btn-success">Mentés</button>
        </div>
      </form>

    <!-- Modal: Útvonal térkép -->
    <div v-if="showUtvonalModal" class="utvonal-modal">
      <div class="utvonal-modal-content">
        <button class="close-button-inside" @click="closeUtvonalModal">&times;</button>

        <h5 class="mb-2">
          Útvonal térkép
          <small v-if="utvonalKm !== null" class="text-muted">
            — Terv út hossza: <b>{{ formatKm(utvonalKm) }}</b> km
          </small>
        </h5>

        <div id="utvonal-modal-map" style="height: 70vh; width: 100%;"></div>

    
      </div>
    </div>





    </div>
  </div>
</template>

<script>
import axiosInstance from "@/axiosInstance";
import $ from "jquery";
import "select2";
import "select2/dist/css/select2.css";
import { mapGetters } from "vuex";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';



export default {
  data() {
    return {
      megrendeles: null,
      selectedMegrendelo: null,
      selectedMegrendeloName: "",
      selectedFelrako: null,
        selectedFelrakoName: '',
        selectedLerako: null,
        selectedLerakoName: '',
        ceg_az: null, // Stellen Sie sicher, dass ceg_az initialisiert wird
        selectedFelHely:null,
        selectedFelHelyName: '',
        selectedLeHely:null,
        selectedLeHelyName: '',
        selectedCikk:null,
        selectedCikkName: '',
        newKm: '', // Neues Feld für den neuen Wert
        newM_datumtol:null,
        newHivatkozasi_szam:'',
        newMegrendeloAr:null,
        selectedTip: null, // Neue ausgewählte Ártípus-ID
        selectedTipName: '', // Neuer ausgewählter Ártípus-Name
        newAlvAr:null,
        selectedAlvTip : null,
        selectedAlvTipName: '',
        newMegjegyzes: '', // Neues Megjegyzés-Feld
        newBelsoHivatkozas: '', // Neues Belső Hivatkozás-Feld
        newGMP: false, // (bei dir in saveOrder verwendet, war aber nicht definiert)

        // --- Útvonal (Route) ---
        utvonalAz: null,
        utvonalKm: null,          // pontvonal_hossz
        kmDiffPct: null,
        utvonalPolyline: null,
        utvonalViszonylat: null,

        routeLoading: false,
        routeTried: false,

        showUtvonalModal: false,
        utvonalMap: null,

           autoUtvonal: false,
        utvonalReloadTimer: null,

    };
  },

  //---------------------
  mounted() {
   // this.fetchOrderDetails();

    this.fetchOrderDetails().then(() => {
    this.$nextTick(() => {
      this.initSelect2();
      this.initSelect2Felrako();
      this.initSelect2Lerako();
      this.initFelhelySelect2();
      this.initSelect2LerakoHely();
      this.initCikkSelect2();
      this.initTipSelect2();
      this.initAlvTipSelect2(); // Füge die Initialisierung hinzu

      this.autoUtvonal = true;
    });
  });


  },

//-----------------------------------

computed: {
  ...mapGetters(["getorderData"]),
  az() { return this.getorderData?.az || null; },
  napifo_az() { return this.getorderData?.napifo_az || null; },

  currentFelrakoAz() {
    return this.selectedFelrako || this.megrendeles?.m_felrakoaz || null;
  },
  currentLerakoAz() {
    return this.selectedLerako || this.megrendeles?.m_lerakoaz || null;
  },

  // ✅ wichtig: wenn Felrakó neu gewählt wurde, aber noch kein neuer Felhely,
  // dann darf NICHT der alte Felhely als Fallback verwendet werden
  currentFelhelyAz() {
    if (this.selectedFelrako && !this.selectedFelHely) return null;
    return this.selectedFelHely || this.megrendeles?.m_felhelyaz || null;
  },
  // ✅ gleiches Prinzip für Lerakó → Lehely
  currentLehelyAz() {
    if (this.selectedLerako && !this.selectedLeHely) return null;
    return this.selectedLeHely || this.megrendeles?.m_lehelyaz || null;
  },

  canLoadUtvonal() {
    return !!(this.megrendeles?.m_cegaz && this.currentFelhelyAz && this.currentLehelyAz);
  }
},


//-------------------------------

watch: {
  currentFelhelyAz() {
    this.queueUtvonalReload();
  },
  currentLehelyAz() {
    this.queueUtvonalReload();
  },

  // optional, aber sinnvoll: wenn Felrakó/Lerakó neu gewählt wird, hely leeren
  currentFelrakoAz() {
    if (!this.autoUtvonal) return;
    this.selectedFelHely = null;
    this.selectedFelHelyName = '';
    $('#felhely_select').val(null).trigger('change');
    this.queueUtvonalReload(); // setzt Route ggf. auf 0, bis neuer hely gewählt
  },
  currentLerakoAz() {
    if (!this.autoUtvonal) return;
    this.selectedLeHely = null;
    this.selectedLeHelyName = '';
    $('#lerakohely_select').val(null).trigger('change');
    this.queueUtvonalReload();
  }
},



//-------------------------------

  methods: {

     queueUtvonalReload() {
    if (!this.autoUtvonal) return;

    if (this.utvonalReloadTimer) clearTimeout(this.utvonalReloadTimer);
    this.utvonalReloadTimer = setTimeout(() => {
      this.loadUtvonalAuto();
    }, 250);
  },

  setUtvonalNone() {
    this.utvonalAz = 0;              // ✅ gefordert
    this.utvonalKm = null;
    this.utvonalPolyline = null;
    this.utvonalViszonylat = null;
    this.kmDiffPct = null;
    this.routeTried = true;
  },

  async loadUtvonalAuto() {
    // wenn nicht genug Daten (fehlender hely), sofort auf 0
    if (!this.canLoadUtvonal) {
      this.setUtvonalNone();
      return;
    }
    await this.loadUtvonal(); // nutzt deine bestehende Methode (unten angepasst)
  },

//-----------    
formatKm(v) {
  const n = Number(v);
  if (!isFinite(n)) return v;
  return n.toFixed(3);
},

recalcKmDiff() {
  const u = Number(this.utvonalKm);

  // wenn kein utvonalKm da ist -> nichts anzeigen
  if (!isFinite(u) || u === 0) {
    this.kmDiffPct = null;
    return;
  }

  // ✅ km-Wert: newKm wenn gesetzt, sonst alter km aus Bestellung
  const kmRaw =
    (this.newKm !== '' && this.newKm !== null && this.newKm !== undefined)
      ? this.newKm
      : (this.megrendeles?.m_km ?? null);

  const km = Number(kmRaw);

  if (!isFinite(km)) {
    this.kmDiffPct = null;
    return;
  }

  const pct = ((km - u) / u) * 100;
  this.kmDiffPct = pct.toFixed(1);
},


async loadUtvonal() {
  if (!this.canLoadUtvonal) {
    this.setUtvonalNone();
    return;
  }

  this.routeLoading = true;
  this.routeTried = true;

  // reset
  this.utvonalAz = null;
  this.utvonalKm = null;
  this.kmDiffPct = null;
  this.utvonalPolyline = null;
  this.utvonalViszonylat = null;

  try {
    const payload = {
      cegaz: this.megrendeles.m_cegaz,
      felMhelyAz: this.currentFelhelyAz,
      leMhelyAz: this.currentLehelyAz
    };

console.log("utvonal payload",payload);

    // gleich wie in newOrder.vue (URL ggf. anpassen falls du es dort anders hast)
    const url = 'https://bogir.hu/V2/api/utvonal/get_utvonal2.php';
    const resp = await axiosInstance.post(url, payload);

    console.log(resp);

    const row = resp?.data?.data?.[0];
    if (!row) {
          this.setUtvonalNone();
          return;
        }

     // ✅ gefunden → alles aktualisieren
     console.log("row.vir_az",row.vir_az);
    this.utvonalAz         = Number(row.vir_az ?? row.az ?? 0);
    this.utvonalKm         = row.pontvonal_hossz ?? row.pontvonalHossz ?? null;
    this.utvonalPolyline   = row.polyline ?? null;
    this.utvonalViszonylat = row.viszonylat ?? null;

    // Diff berechnen, wenn User schon km eingetippt hat
    this.recalcKmDiff();

   } catch (e) {
    console.error('[editOrder] loadUtvonal failed', e);
    // bei Fehler lieber auch auf 0 setzen (damit klar ist: aktuell keine gültige Route)
    this.setUtvonalNone();
  } finally {
    this.routeLoading = false;
  }
},

openUtvonalModal() {
  if (!this.utvonalPolyline) {
    alert('Nincs útvonal (polyline = NULL).');
    return;
  }
  this.showUtvonalModal = true;

  this.$nextTick(() => {
    this.initUtvonalMap();
  });
},

closeUtvonalModal() {
  this.showUtvonalModal = false;

  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }
},

initUtvonalMap() {
  const encoded = this.utvonalPolyline;
  if (!encoded) return;

  // wenn Modal erneut geöffnet wird
  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }

  const coords = this.decodePolyline(encoded, 5);
  if (!coords.length) return;

  const latLngs = coords.map(([lat, lng]) => [lat, lng]);

  this.utvonalMap = L.map('utvonal-modal-map', { preferCanvas: true });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(this.utvonalMap);

  const line = L.polyline(latLngs, { weight: 4 }).addTo(this.utvonalMap);

  // Start / End ohne Icon-Fix (circleMarker)
  L.circleMarker(latLngs[0], { radius: 6 }).addTo(this.utvonalMap).bindPopup('Start');
  L.circleMarker(latLngs[latLngs.length - 1], { radius: 6 }).addTo(this.utvonalMap).bindPopup('Cél');

  this.utvonalMap.fitBounds(line.getBounds(), { padding: [20, 20] });

  setTimeout(() => this.utvonalMap && this.utvonalMap.invalidateSize(), 0);
},

decodePolyline(encoded, precision = 5) {
  if (!encoded || typeof encoded !== 'string') return [];

  let index = 0, lat = 0, lng = 0;
  const coordinates = [];
  const factor = Math.pow(10, precision);

  while (index < encoded.length) {
    let result = 0, shift = 0, b;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += deltaLat;

    result = 0; shift = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += deltaLng;

    coordinates.push([lat / factor, lng / factor]);
  }

  return coordinates;
},

//----------------    
    async fetchOrderDetails() {
      const postData = {
        az: this.napifo_az, // ID der Bestellung
      };

      try {
        console.log("Laden der Bestellung:", postData);
        const url = "/megrendeles/egy_megrendeles.php";
        const response = await axiosInstance.post(url, postData);

        if (response.status === 200 && response.data.data && response.data.data.length > 0) {
          this.megrendeles = response.data.data[0];
          // vorhandene Route (wenn der Endpoint sie liefert)
          this.utvonalKm = this.megrendeles.pontvonal_hossz ?? null;
          this.utvonalPolyline = this.megrendeles.polyline ?? null;
          this.utvonalAz = this.megrendeles.utvonal_az ?? this.megrendeles.utvonalAz ?? null;
          this.utvonalViszonylat = this.megrendeles.viszonylat ?? null;

          // falls User schon newKm eingibt -> Diff
          this.recalcKmDiff();
          console.log("Bestelldaten geladen:", this.megrendeles);

          // Select2 initialisieren
          this.initSelect2();
        } else {
          console.error("Fehler beim Abrufen der Bestelldaten:", response);
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Bestelldaten:", error);
      }
    },


//**************************************************************************************** */
    initSelect2() {
      const vm = this;

      // Select2 Dropdown initialisieren
      $("#megrendelo_select").select2({
        placeholder: "Megrendelő kiválasztása...",
        allowClear: true,
        minimumInputLength: 2,
        ajax: {
          url: "https://bogir.hu/V2/api/megrendelo/list_megrendelo.php",
          type: "POST",
          contentType: "application/json",
          dataType: "json",
          delay: 250,
          headers: {
            Authorization: "Basic " + btoa("Admin_2024$$:S3cure+P@ssw0rd2024!"),
          },
          data: function (params) {
            const payload = {
              search: params.term,
              ceg_az: vm.megrendeles?.m_cegaz || 0,
            };
            console.log("Gesendete Daten:", payload);
            return JSON.stringify(payload);
          },
          processResults: function (response) {
            console.log("Empfangene Daten:", response);
            if (response && response.data && Array.isArray(response.data)) {
              return {
                results: response.data.map((item) => ({
                  id: item.v_kod,
                  text: item.v_nev1,
                })),
              };
            } else {
              console.error("Fehlerhafte Antwort:", response);
              return { results: [] };
            }
          },
          cache: true,
        },
      });

   
      // Event Listener für Auswahl
      $("#megrendelo_select").on("select2:select", function (e) {
        const selectedData = e.params.data;
        vm.selectedMegrendelo = selectedData.id;
        vm.selectedMegrendeloName = selectedData.text;
        console.log("Ausgewählte Megrendelo-ID:", vm.selectedMegrendelo);
        console.log("Ausgewählter Megrendelo-Name:", vm.selectedMegrendeloName);
      });

      // Auswahl zurücksetzen
      $("#megrendelo_select").on("select2:clear", function () {
        vm.selectedMegrendelo = null;
        vm.selectedMegrendeloName = "";
        console.log("Auswahl wurde zurückgesetzt.");
      });
    },

//*********************************************************************************************************************** */
initSelect2Felrako() {
    const vm = this;

    $('#felrako_select').select2({
      placeholder: 'Felrakó kiválasztása...',
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        url: 'https://bogir.hu/V2/api/tav/list_tav.php',
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        delay: 250,
        headers: {
          'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
        },
        data: function (params) {
          return JSON.stringify({
            search: params.term,
            ceg_az: vm.megrendeles?.m_cegaz || 0,
          });
        },
        processResults: function (response) {
          if (response?.data?.length) {
            return {
              results: response.data.map(item => ({
                id: item.tav_az,
                text: item.tav_megn,
              })),
            };
          } else {
            return { results: [] };
          }
        },
        cache: true,
      },
    });

    $('#felrako_select').on('select2:select', function (e) {
      const selectedData = e.params.data;
      vm.selectedFelrako = selectedData.id;
      vm.selectedFelrakoName = selectedData.text;

      // ✅ Felhely zurücksetzen, weil Felrakó sich geändert hat
      vm.selectedFelHely = null;
      vm.selectedFelHelyName = '';
      $('#felhely_select').val(null).trigger('change');

    });

    $('#felrako_select').on('select2:clear', function () {
      vm.selectedFelrako = null;
      vm.selectedFelrakoName = '';

      // ✅ dann wieder Felhely zurücksetzen (und er lädt beim Öffnen über alten Felrakó aus megrendeles)
      vm.selectedFelHely = null;
      vm.selectedFelHelyName = '';
      $('#felhely_select').val(null).trigger('change');

    });
  },

  //**************************************************************** */
  initSelect2Lerako() {
    const vm = this;

    $('#lerako_select').select2({
      placeholder: 'Lerakó kiválasztása...',
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        url: 'https://bogir.hu/V2/api/tav/list_tav.php',
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        delay: 250,
        headers: {
          'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
        },
        data: function (params) {
          return JSON.stringify({
            search: params.term,
            ceg_az: vm.megrendeles?.m_cegaz || 0,
          });
        },
        processResults: function (response) {
          if (response?.data?.length) {
            return {
              results: response.data.map(item => ({
                id: item.tav_az,
                text: item.tav_megn,
              })),
            };
          } else {
            return { results: [] };
          }
        },
        cache: true,
      },
    });

    $('#lerako_select').on('select2:select', function (e) {
      const selectedData = e.params.data;
      vm.selectedLerako = selectedData.id;
      vm.selectedLerakoName = selectedData.text;
    });

    $('#lerako_select').on('select2:clear', function () {
      vm.selectedLerako = null;
      vm.selectedLerakoName = '';
    });
  },

//*************************************************************************************************************** */
// ***************************************************************************************************************
// Felrakó hely (felhely_select)  -> immer currentFelrakoAz verwenden (neu falls gewählt, sonst alter Wert)
initFelhelySelect2() {
  const vm = this;

  $('#felhely_select').select2({
    placeholder: 'Felrakó hely kiválasztása...',
    allowClear: true,
    ajax: {
      url: 'https://bogir.hu/V2/api/hely/list_hely.php',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      delay: 250,
      headers: {
        'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
      },
      data: function () {
        const payload = {
          // ✅ WICHTIG: NICHT vm.selectedFelrako, sondern computed currentFelrakoAz
          hely_tavaz: vm.currentFelrakoAz || 0,
        };
        console.log('[felhely_select] payload:', payload);
        return JSON.stringify(payload);
      },
      processResults: function (response) {
        console.log('[felhely_select] resp:', response);
        const arr = Array.isArray(response?.data) ? response.data : [];
        return {
          results: arr.map(item => ({
            id: item.hely_az,
            text: `${item.hely_ceg} - ${item.hely_cim}`,
          })),
        };
      },
      cache: true,
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('[felhely_select] ajax error:', textStatus, errorThrown);
      },
    },
  });

  $('#felhely_select').on('select2:select', function (e) {
    const d = e.params.data;
    vm.selectedFelHely = d.id;
    vm.selectedFelHelyName = d.text;
    console.log('[felhely_select] selected:', vm.selectedFelHely, vm.selectedFelHelyName);
  });

  $('#felhely_select').on('select2:clear', function () {
    vm.selectedFelHely = null;
    vm.selectedFelHelyName = '';
    console.log('[felhely_select] cleared');
  });
},

// ********************************************************************************************************************
// Lerakó hely (lerakohely_select) -> immer currentLerakoAz verwenden (neu falls gewählt, sonst alter Wert)
initSelect2LerakoHely() {
  const vm = this;

  $('#lerakohely_select').select2({
    placeholder: 'Lerakó hely kiválasztása...',
    allowClear: true,
    ajax: {
      url: 'https://bogir.hu/V2/api/hely/list_hely.php',
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      delay: 250,
      headers: {
        'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
      },
      data: function () {
        const payload = {
          // ✅ WICHTIG: NICHT vm.selectedLerako, sondern computed currentLerakoAz
          hely_tavaz: vm.currentLerakoAz || 0,
        };
        console.log('[lerakohely_select] payload:', payload);
        return JSON.stringify(payload);
      },
      processResults: function (response) {
        console.log('[lerakohely_select] resp:', response);
        const arr = Array.isArray(response?.data) ? response.data : [];
        return {
          results: arr.map(item => ({
            id: item.hely_az,
            text: `${item.hely_ceg} - ${item.hely_cim}`,
          })),
        };
      },
      cache: true,
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('[lerakohely_select] ajax error:', textStatus, errorThrown);
      },
    },
  });

  $('#lerakohely_select').on('select2:select', function (e) {
    const d = e.params.data;
    vm.selectedLeHely = d.id;
    vm.selectedLeHelyName = d.text;
    console.log('[lerakohely_select] selected:', vm.selectedLeHely, vm.selectedLeHelyName);
  });

  $('#lerakohely_select').on('select2:clear', function () {
    vm.selectedLeHely = null;
    vm.selectedLeHelyName = '';
    console.log('[lerakohely_select] cleared');
  });
},

//************************************************************************************************* */
initCikkSelect2() {
  const vm = this;

  $('#cikk_select').select2({
    placeholder: 'Cikk kiválasztása...',
    allowClear: true,
    minimumInputLength: 2,
    ajax: {
      url: 'https://bogir.hu/V2/api/cikk/list_cikk.php', // Dein API-Endpunkt
      type: 'POST',
      contentType: 'application/json', // JSON-Header
      dataType: 'json',
      delay: 250,
      headers: {
        'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
      },
      data: function (params) {
        const payload = {
          search: params.term, // Suchbegriff aus dem Input
          ceg_az: vm.megrendeles.m_cegaz,  // Übergibt den `ceg_az`-Wert
        };

        // Debugging: Zeige die gesendeten Daten an
        console.log('Daten, die an den API-Endpunkt gesendet werden:', payload);

        return JSON.stringify(payload); // JSON-Daten korrekt serialisieren
      },
      processResults: function (response) {
        // Debugging: API-Antwort prüfen
        console.log('Antwort vom Server:', response);

        if (response && response.data && Array.isArray(response.data)) {
          return {
            results: response.data.map(item => ({
              id: item.cikk_az,       // Cikk-ID
              text: item.cikk_megn,   // Cikk-Name
            })),
          };
        } else {
          console.error('Fehlerhafte API-Antwort:', response);
          return { results: [] };
        }
      },
      cache: true, // Zwischenspeichern aktivieren
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Fehler bei der Anfrage:', textStatus, errorThrown);
      },
    },
  });

  // Event Listener: Auswahl speichern
  $('#cikk_select').on('select2:select', function (e) {
    const selectedData = e.params.data;
    vm.selectedCikk = selectedData.id; // Speichert die ID
    vm.selectedCikkName = selectedData.text; // Speichert den Namen

    console.log('Ausgewählte Cikk-ID:', vm.selectedCikk);
    console.log('Ausgewählter Cikk-Name:', vm.selectedCikkName);
  });

  // Event Listener: Zurücksetzen der Auswahl
  $('#cikk_select').on('select2:clear', function () {
    vm.selectedCikk = null;
    vm.selectedCikkName = '';

    console.log('Cikk-Auswahl wurde zurückgesetzt.');
  });
},
//************************************************************************************************ */
initTipSelect2() {
  const vm = this;

  $('#tip_select').select2({
    placeholder: 'Ártípus kiválasztása...',
    allowClear: true,
    minimumInputLength: 1,
    ajax: {
      url: 'https://bogir.hu/V2/api/tip/list_tip.php', // Dein API-Endpunkt
      type: 'POST',
      contentType: 'application/json', // Wichtig für JSON-Daten
      dataType: 'json',
      delay: 250,
      headers: {
        'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
      },
      data: function (params) {
        const payload = {
          search: params.term, // Suchbegriff aus dem Input
          ceg_az: vm.ceg_az,  // Übergibt den `ceg_az`-Wert
        };

        // Debugging: Zeige die gesendeten Daten an
        console.log('Daten, die an den API-Endpunkt gesendet werden:', payload);

        return JSON.stringify(payload); // JSON-Daten korrekt serialisieren
      },
      processResults: function (response) {
        // Debugging: API-Antwort prüfen
        console.log('Antwort vom Server:', response);

        if (response && response.data && Array.isArray(response.data)) {
          return {
            results: response.data.map(item => ({
              id: item.tip_az,       // ID der ártípus
              text: `${item.tip_egyseg} - ${item.tip_megn}`, // Name + Einheit
            })),
          };
        } else {
          console.error('Fehlerhafte API-Antwort:', response);
          return { results: [] };
        }
      },
      cache: true, // Zwischenspeichern aktivieren
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Fehler bei der Anfrage:', textStatus, errorThrown);
      },
    },
  });

  // Event Listener: Auswahl speichern
  $('#tip_select').on('select2:select', function (e) {
    const selectedData = e.params.data;
    vm.selectedTip = selectedData.id; // Speichert die ID
    vm.selectedTipName = selectedData.text; // Speichert den Namen

    console.log('Ausgewählte Tip-ID:', vm.selectedTip);
    console.log('Ausgewählter Tip-Name:', vm.selectedTipName);
  });

  // Event Listener: Zurücksetzen der Auswahl
  $('#tip_select').on('select2:clear', function () {
    vm.selectedTip = null;
    vm.selectedTipName = '';

    console.log('Ártípus-Auswahl wurde zurückgesetzt.');
  });
},

  //*********************************************************************************************************** */
  initAlvTipSelect2() {
  const vm = this;

  $('#alvTip_select').select2({
    placeholder: 'Ártípus kiválasztása...',
    allowClear: true,
    minimumInputLength: 1,
    ajax: {
      url: 'https://bogir.hu/V2/api/tip/list_tip.php', // Dein API-Endpunkt
      type: 'POST',
      contentType: 'application/json', // Wichtig für JSON-Daten
      dataType: 'json',
      delay: 250,
      headers: {
        'Authorization': 'Basic ' + btoa('Admin_2024$$:S3cure+P@ssw0rd2024!'),
      },
      data: function (params) {
        const payload = {
          search: params.term, // Suchbegriff aus dem Input
          ceg_az: vm.ceg_az,  // Übergibt den `ceg_az`-Wert
        };

        // Debugging: Zeige die gesendeten Daten an
        console.log('Daten, die an den API-Endpunkt gesendet werden:', payload);

        return JSON.stringify(payload); // JSON-Daten korrekt serialisieren
      },
      processResults: function (response) {
        // Debugging: API-Antwort prüfen
        console.log('Antwort vom Server:', response);

        if (response && response.data && Array.isArray(response.data)) {
          return {
            results: response.data.map(item => ({
              id: item.tip_az,       // ID der ártípus
              text: `${item.tip_egyseg} - ${item.tip_megn}`, // Name + Einheit
            })),
          };
        } else {
          console.error('Fehlerhafte API-Antwort:', response);
          return { results: [] };
        }
      },
      cache: true, // Zwischenspeichern aktivieren
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Fehler bei der Anfrage:', textStatus, errorThrown);
      },
    },
  });

  // Event Listener: Auswahl speichern
  $('#alvTip_select').on('select2:select', function (e) {
    const selectedData = e.params.data;
    vm.selectedAlvTip = selectedData.id; // Speichert die ID
    vm.selectedAlvTipName = selectedData.text; // Speichert den Namen

    console.log('Ausgewählte Alvállalkozói ártípus-ID:', vm.selectedAlvTip);
    console.log('Ausgewählte Alvállalkozói ártípus-Name:', vm.selectedAlvTipName);
  });

  // Event Listener: Zurücksetzen der Auswahl
  $('#alvTip_select').on('select2:clear', function () {
    vm.selectedAlvTip = null;
    vm.selectedAlvTipName = '';

    console.log('Alvállalkozói ártípus-Auswahl wurde zurückgesetzt.');
  });
},
//****************************************************************************************************** */







  fetchCegAz() {
    // Laden Sie den Wert von ceg_az für beide Select2-Felder, falls nötig
    if (this.megrendeles) {
      this.ceg_az = this.megrendeles.m_cegaz || 0;
    }
  },

//**************************************************************************************************** */

async saveOrder() {
  // Erstelle ein Objekt für die geänderten Daten
  const changedData = {};

console.log('this.selectedFelHely)',this.selectedFelHely);
console.log('this.selectedFelHelyName)',this.selectedFelHelyName);

  // Prüfe und füge geänderte Werte hinzu
  if (this.selectedMegrendelo && this.selectedMegrendelo !== this.megrendeles.m_megrendeloaz) {
    changedData.m_megrendeloaz = this.selectedMegrendelo;
    changedData.megrendelo = this.selectedMegrendeloName;
   
  }

  if (this.selectedFelrako && this.selectedFelrako !== this.megrendeles.felrako) {
    changedData.m_felrakoaz = this.selectedFelrako;
    changedData.felrako = this.selectedFelrakoName;
    
  }

  if (this.selectedFelHely && this.selectedFelHely !== this.megrendeles.m_felhelyaz) {
    
    changedData.m_felhelyaz = this.selectedFelHely;
    changedData.fhely = this.selectedFelHelyName;
  }


  if (this.selectedLerako && this.selectedLerako !== this.megrendeles.lerako) {
    changedData.m_lerakoaz = this.selectedLerako;
    changedData.lerako = this.selectedLerakoName;
  }

  if (this.selectedLeHely && this.selectedLeHely !== this.megrendeles.m_lehelyaz) {
    changedData.m_lehelyaz = this.selectedLeHely;
    changedData.lhely = this.selectedLeHelyName;
  }


  if (this.selectedCikk && this.selectedCikk !== this.megrendeles.cikk) {
    changedData.m_cikkaz = this.selectedCikk;
    changedData.cikk = this.selectedCikkName;
  }


  if (this.newKm && this.newKm !== this.megrendeles.m_km) {
    changedData.m_km = this.newKm;
  }

  if (this.newHivatkozasi_szam && this.newHivatkozasi_szam !== this.megrendeles.hivatkozasi_szam) {
    changedData.hivatkozasi_szam = this.newHivatkozasi_szam;
  }

  if (this.newGMP !== undefined && this.newGMP !== (this.megrendeles.gmp === -1)) {
    changedData.gmp = this.newGMP ? -1 : 0;
  }

  if (this.newMegrendeloAr && this.newMegrendeloAr !== this.megrendeles.m_aregysegar) {
    changedData.m_aregysegar = this.newMegrendeloAr;
  }

  if (this.selectedTip && this.selectedTip !== this.megrendeles.m_tipaz) {
    changedData.m_artipaz = this.selectedTip;
    changedData.m_egysegarme = this.selectedTipName;
  }
  
  if (this.newAlvAr && this.newAlvAr !== this.megrendeles.mar_egysegar) {
    changedData.mar_egysegar = this.newAlvAr;
  }

  if (this.selectedAlvTip && this.selectedAlvTip !== this.megrendeles.mar_tipaz) {
    changedData.mar_artipaz = this.selectedAlvTip;
    changedData.mar_egysegarme = this.selectedAlvTipName;

  }
  if (this.newMegjegyzes && this.newMegjegyzes !== this.megrendeles.megjegyzes) {
    changedData.megjegyzes = this.newMegjegyzes;
  }
  if (this.newBelsoHivatkozas && this.newBelsoHivatkozas !== this.megrendeles.belsoHivatkozas) {
    changedData.belsoHivatkozas = this.newBelsoHivatkozas;
    changedData.m_az=0;
  }

 const oldUtvonalAzNum = Number(this.megrendeles.utvonal_az ?? this.megrendeles.utvonalAz ?? 0);
const newUtvonalAzNum = Number(this.utvonalAz ?? 0);

if (newUtvonalAzNum !== oldUtvonalAzNum) {
  changedData.utvonalAz = newUtvonalAzNum; // ✅ kann 0 sein
}

  // Überprüfe, ob es Änderungen gibt
  if (Object.keys(changedData).length === 0) {
    alert('Nem történt módosítás.');
    return;
  }

  // Erstelle die Post-Daten
  const postData = {
    az: this.megrendeles.az,
    data: changedData,
  };

  try {
    console.log('Zu speichernde Daten:', postData);
    const response = await axiosInstance.post('/megrendeles/api_update_megrendeles.php', postData);
    if (response.data.success) {
      //alert('mentés OK');
      this.$router.push('/osszesMegrendeles');
    } else {
      console.error('Fehler beim Speichern:', response.data);
      alert('Hiba a mentés során',response.data);
    }
  } catch (error) {
    console.error('Fehler beim Speichern:', error);
    alert('Hiba a mentös során',error);
  }
},


    cancel() {
      this.$router.push("/osszesMegrendeles");
    },
  },
};
</script>

<style scoped>

.form-group {
  margin-bottom: 0px; /* Verringert den Abstand zwischen den Zeilen */
}

.form-group.row.align-items-center {
  padding: 2px 0; /* Verringert den inneren Abstand */
}

.container-fluid {
  padding: 10px;
}
.btn-container {
  display: flex;
  justify-content: center; /* Zentriert die Buttons horizontal */
  gap: 10px; /* Fügt Abstand zwischen den Buttons hinzu */
  margin-top: 20px; /* Beibehaltung des Abstands nach oben */
}

.utvonal-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.utvonal-modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-height: 85%;
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: left;
}

/* Close Button (du hast ihn schon, hier nur falls nicht vorhanden) */
.close-button-inside {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  color: #333;
}



</style>
